import Axios from "axios"
import config from "../../Configs/Config"
const konnect=Axios.create({
    baseURL:config.base_url,
    // baseURL:'http://172.16.1.157:9090',
    // baseURL:'https://api.konnect.bio',
    // baseURL:'http://172.16.1.85:9090',
})
export default konnect